import React from "react";
import api from "../../api/requests";

const initialData = {
  requestsList: []
};

export default function useRequests() {
  const [requestsData, setRequestsData_] = React.useState(initialData);

  const setRequestsData = newData => {
    const newRequestsData = {
      ...requestsData,
      ...newData
    };

    setRequestsData_(newRequestsData);
  };

  function getRequests() {
    api.getRequestList().then(({ data }) => setRequestsData({ requestsList: data }));
  }

  return { requestsData, getRequests};
}
